import {LookUpModel} from "../types/AppState";

export const lookUpResolver = (val?:string,metaLookUps?:LookUpModel[]) => {
    return metaLookUps?.find(i => i.value == val)?.label || val || "";
}